module.exports = __webpack_public_path__ + "img/1.a3c9aa73.jpg";